export const formatCurrency = (amount = 0, language: string, currency = "EUR"): string => {
  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  };

  if (Number.isInteger(amount)) {
    options.minimumFractionDigits = 0;
  }

  return new Intl.NumberFormat(language, options).format(amount);
};
